import api from './axiosInstance';
import i18n from '../i18n';

export const getSalesFunnel = async (userId) => {
    try {
        const response = await api.get(`/sales-funnel/${userId}`)
        return response.data;
    } catch (error) {
        console.error('Error fetching sales funnel:', error);
        throw new Error(i18n.t('salesService.load_sales_funnel_error'));
    }
};